<template>
  <PanelV2
    type="w9"
    mode="simple"
    showGoBack
  >
    <template v-slot:content-solt>
      <span class="title">Need help with your account?</span>
      <div class="branch" @click="toBranch(item)" v-for="item in branches" :key="item.path">
        <span>{{ item.title }}</span>
        <img src="@/assets/pc/icon_arrow down.svg" />
      </div>
    </template>
  </PanelV2>
</template>

<script>
  export default {
    name: 'NeedHelp',
    pRouter: 'App',
    data() {
      return {
        branches: [
          {
            title: 'I forgot my email',
            desc: '',
            path: 'ForgotEmail',
          },
          {
            title: 'I forgot my password',
            desc: '',
            path: 'ForgotPassword',
          },
        ],
      }
    },
    methods: {
      toBranch ({path}) {

        this.routerChange({name: path})
      }
    }
  }
</script>


<style lang="scss" scoped>

  .panel-v2 {
    height: 600px;

    .title {
      font: normal normal normal 22px/24px Nunito-bold;
      letter-spacing: 0px;
      color: #2E2E2E;
      width: 100%;
    }

    .branch {
      cursor: pointer;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      margin: 32px 0 0;

      font: normal normal normal 20px/24px Nunito-bold;
      letter-spacing: 0px;
      color: #0072D8;

      img {
        width: 50px;
        transform: rotate(-90deg);
      }
    }
  }
</style>
